import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslocoModule } from '@jsverse/transloco';
import { PipesModule } from '@cbcore/pipes/pipes.module';
import { Config } from "@cbcore/services/config/config.service";
import { CalculationsService } from "@cbcore/services/utils/calculations/calculations.service";
import { RacingUnitsDistributionBase } from '../base/racing-units-distribution.base';

@Component({
    selector: 'ud-greyhounds',
    templateUrl: './default/greyhounds/greyhounds.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslocoModule, PipesModule]
})
export class GreyhoundsComponent extends RacingUnitsDistributionBase {
  constructor(
    protected override _config: Config,
    protected override _calculationsService: CalculationsService
  ) {
    super(_config, _calculationsService);
  }

  protected override initializeUrls(): void {
    this.imagesUrl = this._config.CONFIG.imagesUrl;
  }
}